import { c as _c } from "react/compiler-runtime";
import { SmartPhone01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
export function RotateDeviceOverlay() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="pointer-events-none fixed inset-0 z-[1000] hidden items-center justify-center bg-background text-foreground [@media(max-width:768px)_and_(orientation:landscape)_and_(pointer:coarse)]:flex"><Alert className="mx-6 flex max-w-sm flex-col border-border/70 bg-card px-5 py-4 text-center shadow-none"><HugeiconsIcon icon={SmartPhone01Icon} className="mx-auto size-12 rotate-90" strokeWidth={1.5} /><AlertTitle className="mt-3 justify-self-center text-center text-base">Rotate to portrait</AlertTitle><AlertDescription className="mt-1 text-center">Use Clutch in portrait mode for the best experience.</AlertDescription></Alert></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}